import React from 'react'

import ParticipantFileDetails from 'modules/resultsV2/components/ParticipantFileDetails/ParticipantFileDetails'
import type { DataAccessRequestParticipantFile } from 'services/results/types'

import { DownloadDataAccessRequestParticipantFile } from './DownloadDataAccessRequestParticipantFile'

interface DataAccessRequestParticipantFileDetailsProps {
  hasBorder?: boolean
  isDownloadDisabled?: boolean
  isDownloadLoading?: boolean
  requestId: string
  participantFile?: DataAccessRequestParticipantFile
}

export const DataAccessRequestParticipantFileDetails = ({
  hasBorder,
  isDownloadDisabled = false,
  isDownloadLoading = false,
  requestId,
  participantFile
}: DataAccessRequestParticipantFileDetailsProps): JSX.Element | null => (
  <ParticipantFileDetails
    downloadAction={<DownloadDataAccessRequestParticipantFile requestId={requestId} />}
    hasBorder={hasBorder}
    isDownloadDisabled={isDownloadDisabled}
    isDownloadLoading={isDownloadLoading}
    participantFile={participantFile}
    resultId={requestId}
  />
)
